import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mkwgw6t63p: FaireBrandEntity = {
  token: "b_mkwgw6t63p",
  type: "brand",
  name: "Potluck",
  avatarUrl:
    "https://cdn.faire.com/fastly/a23d5b8893e86976871a8b5f0deb134d0acceb428bd589909ad7dcc8abe96f12.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c9ac82e1b5d29cc0f2f2bdfe9d1bb645665179818a7e4e25328cff3f10929339.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a23d5b8893e86976871a8b5f0deb134d0acceb428bd589909ad7dcc8abe96f12.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c9ac82e1b5d29cc0f2f2bdfe9d1bb645665179818a7e4e25328cff3f10929339.png",
  location: "Boston, MA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "All-natural Korean staples for every pantry. We’re reimagining the classics and partnering with a network of skilled makers to do it. Potluck is bold flavors and no fillers—grounded in tradition but not bound by its rules. We’re meant for big nights, dinners-for-one, potlucks and pick-me-ups.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:08.070Z",
    importedBy: "entity-db-cli",
  },
};
